import { EDITOR_ORIGIN } from '~/constants/editor';
import { drop } from 'ramda';

import { Hint } from './Hint';

class CommandHint implements Hint {
  name = 'command';

  origin = EDITOR_ORIGIN.COMMAND_COMPLETE;

  fromDistance = 1;

  checkActive(text: string, cursor?: { line: number; ch: number }): boolean {
    return cursor.line === 0 && /^\/[^/ ]*$/.test(text);
  }

  convertItemToText({ name }: { name: string }) {
    return `${name} `;
  }

  getQuery(text: string): string {
    return drop(1, text);
  }
}

export default new CommandHint();
